"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getContrastingTextColor = require("../../utils/getContrastingTextColor");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Dialog = {
  styles: function styles(theme) {
    return {
      small: {
        padding: theme.spacing.base * 2
      },
      medium: {
        padding: theme.spacing.base * 2
      },
      defaultDialogBoxStyles: {
        border: "none",
        borderRadius: 12,
        backgroundColor: theme.colors.pageBackground,
        padding: theme.spacing.base * 4
      },
      title: {
        textTransform: "uppercase",
        fontWeight: 500,
        fontFamily: 'Raleway, "Helvetica Neue", "Helvetica", "Arial", sans-serif',
        letterSpacing: 0.44
      },
      content: {
        fontSize: theme.typography.fontSize,
        color: theme.colors.baseContrast085
      },
      actions: {
        marginTop: theme.spacing.base * 2
      },
      button: {
        "& label": {
          color: theme.colors.baseContrast085
        },
        "&:last-child > label": {
          color: (0, _getContrastingTextColor.getContrastingTextColorHexString)(theme.colors.primary, undefined, undefined, _getContrastingTextColor.PRIMARY_CONTRAST_STANDARD)
        }
      },
      svgIcon: {
        width: 20,
        height: 20,
        minHeight: 20,
        minWidth: 20
      }
    };
  }
};
var _default = exports.default = Dialog;